export const IconMotorcycle = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path d="M12.703 5c.46 0 .881.252 1.097.656l.44.81 1.482-1.234c.181-.15.406-.232.64-.232H17a1 1 0 0 1 1 1v1c0 .553-.447 1-1 1h-1.931l1.722 3.16c.38-.094.787-.16 1.209-.16a4 4 0 1 1-4 4c0-1.278.575-2.366 1.472-3.1l-.481-.894C13.753 11.92 13 13.37 13 15c0 .316.034.678.1 1h-2.2c.066-.322.072-.684.072-1 0-2.762-2.21-5-5-5h-3V9c0-.553.476-1 1-1h3.2c.531 0 1.037.21 1.412.584L9.972 10l3.094-2.553-.513-.947h-1.831a.77.77 0 0 1-.75-.75c0-.414.362-.75.75-.75zM16 15c0 1.103.897 2 2 2s2-.897 2-2a2 2 0 0 0-2.222-1.988l.881 1.632a.749.749 0 1 1-1.318.712l-.882-1.631A2 2 0 0 0 16 15m-6.069.75a4 4 0 1 1 0-1.5H7.853A2 2 0 1 0 6 17c.84 0 1.56-.516 1.853-1.25zM5 15a.999.999 0 1 1 2 0 .999.999 0 1 1-2 0" />
    </svg>
  );
};
